import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=662e70c7&scoped=true&"
import script from "./normal.vue?vue&type=script&lang=js&"
export * from "./normal.vue?vue&type=script&lang=js&"
import style0 from "./normal.vue?vue&type=style&index=0&id=662e70c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662e70c7",
  null
  
)

export default component.exports